import React, { useEffect, useState } from "react";
import CommonTable from "../../../components/comman/CommonTable";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  Fade,
  TabPane,
} from "reactstrap";

const PendingLeaveRequests = ({ siteId }) => {
  const navigate = useNavigate();

  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    leavesList: [],
    activeTab: "1",
  });

  const toggleTab = (tab) => {
    setPageStates((prev) => ({
      ...prev,
      activeTab: tab,
    }));
  };

  useEffect(() => {
    GetLeaveReq();
  }, [siteId, pageStates?.activeTab]);

  const GetLeaveReq = () => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_leave +
      `?pageNumber=1&pageSize=5&myLeave=false&status=0&type=${pageStates?.activeTab}${siteId ? `&siteId=${siteId}` : ""}`
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.leave?.map((item) => ({
          ...item,
          employeeCode: item?.user?.employeeCode,
          empNameWithImage: item?.user?.name + "##" + item?.user?.profilePhoto,
          employeeDept: item?.user?.department?.name,
          officeName: item?.user?.site?.name,
          siteName: item?.user?.usersites?.[0]?.site?.name,
          appliedOn: moment(item?.createdAt).format("DD/MM/YYYY"),
          fromDate: moment(item.startDate).format("DD/MM/YYYY"),
          toDate: moment(item.endDate).format("DD/MM/YYYY"),
          days: moment(item.endDate).diff(moment(item.startDate), "days") + 1,
          leaveStatus: item?.status,
        }));
        setPageStates((pre) => ({
          ...pre,
          leavesList: newData,
        }));
      }
    });
  };

  const TableHeading = [
    { value: "empNameWithImage", label: "Employee" },
    { value: "employeeCode", label: "Emp. Code" },
    { value: "employeeDept", label: "Emp. Dept." },
    ...(pageStates?.activeTab == 1
      ? [{ value: "officeName", label: "Office" }]
      : [{ value: "siteName", label: "Site" }]),
    { value: "leaveType", label: "Leave Type" },
    { value: "appliedOn", label: "Applied On" },
    { value: "fromDate", label: "From" },
    { value: "toDate", label: "To" },
    { value: "days", label: "Days" },
    { value: "leaveStatus", label: "Status" },
  ];

  const HandleView = (data) => {
    navigate(`${RoutesLink?.leave_detail}/${data?.id}`, {
      state: { type: "teamLeaveRequest" },
    });
  };

  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  return (
    <div className="col-12 col-lg-8">
      <div className="card">
        <div className="card-body">
          <div className="card-head">
            <h3 className="card-title">Leave Requests</h3>

            <button
              type="button"
              className="btn btn-outline-primary py-1"
              onClick={() => navigate(RoutesLink?.leave_request)}
            >
              View All
            </button>
          </div>
          <Nav tabs className="nav nav-tabs border-0 mb-4">
            <NavItem className="nav-item">
              <NavLink
                className={
                  pageStates?.activeTab === "1"
                    ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2 active"
                    : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab("1")}
              >
                Office Leave Requests
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  pageStates?.activeTab === "0"
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab("0")}
              >
                Site Leave Reaquests
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={pageStates?.activeTab}>
            <TabPane tabId={"1"}>
              <Fade in={pageStates?.activeTab === "1"} timeout={200}>
                <CommonTable
                  TableHeading={TableHeading}
                  TableData={pageStates?.leavesList}
                  ActionData={ActionData}
                  isLoading={pageStates?.tableLoader}
                />
              </Fade>
            </TabPane>
            <TabPane tabId={"0"}>
              <Fade in={pageStates?.activeTab === "0"} timeout={200}>
                <CommonTable
                  TableHeading={TableHeading}
                  TableData={pageStates?.leavesList}
                  ActionData={ActionData}
                  isLoading={pageStates?.tableLoader}
                />
              </Fade>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </div>
  );
};

export default PendingLeaveRequests;
